import { Component, type ErrorInfo, type ReactNode } from 'react'
import i18n from '../i18n'

type Props = { children: ReactNode }
type State = { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught', error, info.componentStack)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (!this.state.error) return this.props.children
    // i18n.t is used directly: a thrown error may have unmounted the
    // I18nextProvider tree, so useTranslation() inside the fallback is unsafe.
    const t = i18n.t.bind(i18n)
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-sm space-y-4 rounded-xl bg-white p-8 shadow text-center">
          <h1 className="text-base font-semibold text-gray-900">{t('errors.boundaryTitle')}</h1>
          <p className="text-sm text-gray-500">{t('errors.boundaryBody')}</p>
          <button
            onClick={this.handleReload}
            className="w-full rounded-md bg-gray-900 px-3 py-2 text-sm font-medium text-white hover:bg-gray-800"
          >
            {t('errors.boundaryReload')}
          </button>
        </div>
      </div>
    )
  }
}
